import * as angular from "angular";

function addSkinToScope($rootScope, triSkins) {
  $rootScope.triSkin = triSkins.getCurrent();
}

angular
  .module('triangular.themes')
  .run(addSkinToScope);
